import { Stack, Typography } from "@mui/material";
import { DrillDownPage } from "../../../../store/types/drillDownPageState.types";

interface Props {
  configuration: DrillDownPage;
}

export const PortfolioMonitoringTitle = ({ configuration }: Props) => {
  const measureCaption = configuration.measure?.config.customLabel || configuration.measure?.meta.caption;

  return (
    <Stack py={1.5} gap={0.3}>
      <Typography variant="h6">Portfolio Monitoring Ledger</Typography>
      <Stack direction="row" gap={1}>
        {measureCaption && (
          <Typography variant="caption" color="text.secondary">
            {measureCaption} &#xa0;&bull;
          </Typography>
        )}
        {configuration.cell.formattedValue && (
          <Typography variant="caption" color="text.secondary">
            {configuration.cell.formattedValue}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
export default PortfolioMonitoringTitle;
